<template>
    <section v-if="newBizParam">
        <!-- 规则1 start-->
        <div class="rule" style="border-bottom: 1px solid #d9d9d9;padding-bottom: 16px;margin-bottom:16px">
            <!-- <h5></h5> -->
            <el-checkbox @change="changeCheck(1);$emit('changeData',newBizParam)" v-model="newBizParam.dayCustomerSameSum.enabled"></el-checkbox>
            <span class="txt">规则1：</span>
            <span class="txt">同企业所有人员同一天内，提交<i class="theme-color">同一家企业客户</i>的频次</span>
         
        </div>
        <div class="rule-child" v-if="newBizParam.dayCustomerSameSum.enabled">
            <div class="rule" v-for="(item,index) in newBizParam.dayCustomerSameSum.ruleItemList" :key="index">
                <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)"  v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{ CUSTOMERTYPEMAP[item.customerType] }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input @input="$forceUpdate();$emit('changeData',newBizParam)"  class="rule-input-box" v-model="item.sumLimitMax" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
            </div>
        </div>
        <!-- 规则1 end-->
    </section>
</template>
  
<script>
import { CUSTOMERTYPEMAP, CustomerTypeEnum } from "./enum.js";
export default {
    props: ['bizParam1'],
    data() {
        return {
            CUSTOMERTYPEMAP,
            CustomerTypeEnum,
            isOpenCheck:false,
            optionSCDY1: [
                {
                    value: '3',
                    label: '医生',
                },
                {
                    value: '10',
                    label: '商业客户',
                },
                {
                    value: '11',
                    label: '居间人',
                },
                {
                    value: '15',
                    label: '药店联系人',
                },
            ],
            isSamePersonOption:[
                {
                    value: 'Y',
                    label: '同一人员',
                },
                {
                    value: 'N',
                    label: '不同人员',
                },
            ],
            newBizParam:null,

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
                if (!this.$route.query.guid&&this.$route.query.type!=3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                this.$forceUpdate();
            }
        }
    },
    created() {
       if (this.$route.query.guid||this.$route.query.type==3) return
       this.newBizParam = this.bizParam1;
       
    },
    methods: {
        changeCheck(i) {
            //规则1
            if (!this.newBizParam.dayCustomerSameSum.enabled && i == 1) {
                this.newBizParam.dayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                        
                        {
                            "enabled": false,
                            "customerType": CustomerTypeEnum.hospital,
                            "sumLimitMax": null
                        },
                       
                    ]
                }
            }
            
            
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let {  dayCustomerSameSum } = this.newBizParam;
            //规则1 校验
            try {
                let count = 0;
                dayCustomerSameSum.ruleItemList.forEach(k => {
                    if (dayCustomerSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 1) {
                        throw new Error('请勾选限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            return true;
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}
.w260{
    width: 260px; 
}

.w130 {
    width: 140px;
}

.rule-input-box {
    width: 90px;
}
.txt{
    margin:0 10px;
}
.theme-color{
    color:#4FA1A4;
    font-style: normal;
}
.tips-color{
    color:red;
    font-style: normal;
}
.rule-child{
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
    /* margin-left: 140px; */
}
.tips{
    color:red;
    font-size: 12px;
}
.red-border{
    border: 1px solid red;
    border-radius: 4px;
}
.red-border /deep/ .el-input__inner{
    border: 0 none;
}
span{
    display: inline-block;
}
.rule-child .rule:last-child{
    margin-bottom: 0px;
}
.line{
    height: 1px;
    background: #d9d9d9;
    margin:16px 0;
}
h5{
    font-size: 14px;
    color: #212212;
    width: 140px;
    text-align: left;
    margin:0;
    font-weight: normal;
}
</style>
  